import React, { useRef, useEffect } from 'react';
import { formatTimeSeconds } from '@modules/database/work-items/frontend/utils/fieldUtils';

function TimeEditor({ value, onChange, disabled, onKeyDown }) {
  const inputRef = useRef(null);

  // Convert seconds (from Jira) to display string on mount
  const displayValue = typeof value === 'number' ? formatTimeSeconds(value) : (value || '');

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, []);

  return (
    <div className="time-editor">
      <input
        ref={inputRef}
        type="text"
        className="field-editor-input"
        value={typeof value === 'string' ? value : displayValue}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={disabled}
        placeholder="e.g. 1w 2d 4h 30m"
      />
      <div className="time-editor-hint">
        Use Jira time format: w = weeks, d = days, h = hours, m = minutes
      </div>
    </div>
  );
}

export default TimeEditor;
